export const DEFAULT_PREVIEW_VALUES = {
    TENANT_LEGAL_NAME: "Cat Hotel Floki BV",
    TENANT_VAT: "BE0123.456.789",
    TENANT_ADDRESS: "Kattenstraat 1, 1000 Brussel",
    TENANT_EMAIL: "info@cathotel.example",
    TENANT_PHONE: "+32 470 00 00 00",
    CUSTOMER_NAME: "John Doe",
    CUSTOMER_ADDRESS: "Examplelaan 10, 9000 Gent",
    CUSTOMER_EMAIL: "john.doe@example.com",
    CUSTOMER_PHONE: "+32 470 11 11 11",
    DATE_TODAY: "19-01-2026",

    ANIMAL_CONTACT_OTHERS: "Ja",
    ANIMAL_DIEET: "Geen",
    ANIMAL_MEDICATION: "Geen",
    ANIMAL_TYPE: "Ras van het dier",
    ANIMAL_CHIP_NUMBER: "12345678998754",
    ANIMAL_BIRTHDATE: "03/05/2004",
    ANIMAL_SEX: "Mannelijk",
    ANIMAL_COLOR: "Wit met grijs",
    ANIMAL_BEHAVIOR_HOME: "Lief",
    ANIMAL_BEHAVIOR_OTHER_ANIMALS: "Geen probleem",
    ANIMAL_VET_NAME: "Dr John Doe",
    ANIMAL_VET_LEGA_NAME: "De dieren praktijk",
    ANIMAL_VET_ADRESS: "Vet straat 1, 1000 Brussel",
    ANIMAL_VET_PHONE: "+32/213.56.56",
    EMERGENCY_CONTACT_NAME: "Jean Doe",
    EMERGENCY_ADRESS: "Jean Doe straat 1, 1000 Brussel",
    EMERGENCY_PHONE: "+32/000.02.60",

    RESERVATION_NUMBER: "R-2026-0001",
    CHECK_IN_DATE: "01-02-2026",
    CHECK_IN_HOUR: "15:00",
    CHECK_OUT_DATE: "05-02-2026",
    CHECK_OUT_HOUR: "10:00",
    ANIMAL_NAMES_IN_RESERVATION: "Minoes, Floki",
    RESERVATION_TOTAL_AMOUNT: "€ 120,00",
    RESERVATION_ADVANCE: "€ 30,00",
    RESERVATION_REMAINING_AMOUNT: "€ 90,00",
    RESERVATION_STAY: "Standaard",
};

export const CONTRACT_COMMON_PARAMS = [
    "TENANT_LEGAL_NAME",
    "TENANT_VAT",
    "TENANT_ADDRESS",
    "TENANT_EMAIL",
    "TENANT_PHONE",
    "CUSTOMER_NAME",
    "CUSTOMER_ADDRESS",
    "CUSTOMER_EMAIL",
    "CUSTOMER_PHONE",
    "DATE_TODAY",
];

export const CONTRACT_RESERVATION_PARAMS = [
    "RESERVATION_NUMBER",
    "CHECK_IN_DATE",
    "CHECK_IN_HOUR",
    "CHECK_OUT_DATE",
    "CHECK_OUT_HOUR",
    "RESERVATION_STAY",
    "ANIMAL_NAMES_IN_RESERVATION",
    "RESERVATION_TOTAL_AMOUNT",
    "RESERVATION_ADVANCE",
    "RESERVATION_REMAINING_AMOUNT",
    "ANIMAL_BIRTHDATE",
    "ANIMAL_SEX",
    "ANIMAL_CONTACT_OTHERS",
    "ANIMAL_DIEET",
    "ANIMAL_MEDICATION",
    "ANIMAL_TYPE",
    "ANIMAL_CHIP_NUMBER",
    "ANIMAL_COLOR",
    "ANIMAL_BEHAVIOR_HOME",
    "ANIMAL_BEHAVIOR_OTHER_ANIMALS",
    "ANIMAL_VET_NAME",
    "ANIMAL_VET_LEGA_NAME",
    "ANIMAL_VET_ADRESS",
    "ANIMAL_VET_PHONE",
    "EMERGENCY_CONTACT_NAME",
    "EMERGENCY_ADRESS",
    "EMERGENCY_PHONE",
];

export const DEFAULT_CONTRACT_CSS = `
* { box-sizing: border-box; }
body { font-family: Arial, Helvetica, sans-serif; font-size: 16px; font-style: normal; line-height: 1.2; color: #111; }
p { font-size: 16px; line-height: 1.2; margin: 0 0 15px 0; }
h1 { font-size: 17px; font-weight: bold; margin: 35px 0 25px 0; }
h2 { font-size: 16px; font-weight: bold; margin: 35px 0 25px 0; }
ul, ol { margin: 0 0 4mm 0; padding-left: 2mm; list-style-position: outside; }
ul { list-style-type: disc; margin: 0px 0 25px 0; }
ol { list-style-type: decimal; margin: 5px 0 5px 0; }
li { display: list-item; line-height: 1.2; margin: 0 0 1.5mm 0; }
.page-break { page-break-before: always; }
table { width: 100%; border-collapse: collapse; margin: 4mm 0; font-size: 10.5pt; }
td, th { border: 1px solid #ddd; padding: 6px; vertical-align: top; }
th { font-weight: bold; }
.small { font-size: 9pt; line-height: 1; }
img { max-width: 100%; height: auto; }
@page { size: A4; margin: 18mm 14mm; }
`;

export const editorPdfLikeSx = (t) => ({
    "& .MuiTiptap-RichTextField-menuBarContent": {
        position: "sticky",
        top: 0,
        zIndex: 20,
        backgroundColor: "rgb(246,246,246)",
        borderBottom: "1px solid",
        borderTop: 1,
        borderTopLeftRadius: 5,
        borderColor: "divider",
    },
    "& .MuiTiptap-FieldContainer-root-MuiTiptap-RichTextField-root": {
        borderRadius: 0
    },
    "& .MuiTiptap-Controls": {
        position: "sticky",
        top: 0,
        zIndex: 10,
        backgroundColor: "background.paper",
        borderBottom: 1,
        borderColor: "divider",
    },
    "& .ProseMirror": {
        boxSizing: "border-box",
        fontFamily: "Arial, Helvetica, sans-serif",
        fontSize: "16px",
        fontStyle: "normal",
        color: "#111",
    },

    "& .ProseMirror *": {
        boxSizing: "border-box",
    },

    "& .ProseMirror h1": {
        fontSize: "17px",
        fontWeight: "bold",
        margin: "35px 0 25px 0",
    },

    "& .ProseMirror h2": {
        fontSize: "16px",
        fontWeight: "bold",
        margin: "35px 0 25px 0",
    },

    "& .ProseMirror p": {
        fontSize: "16px",
        lineHeight: "1.2",
        margin: "0 0 15px 0 !important",
    },

    "& .ProseMirror table": {
        width: "100%",
        borderCollapse: "collapse",
        margin: "4mm 0",
        fontSize: "10.5pt",
    },

    "& .ProseMirror td, & .ProseMirror th": {
        border: "1px solid #ddd",
        padding: "6px",
        verticalAlign: "top",
        position: "relative",
    },

    "& .ProseMirror .selectedCell:after": {
        zIndex: 2,
        position: "absolute",
        content: '""',
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        background: "rgba(200, 200, 255, 0.4)",
        pointerEvents: "none",
    },

    "& .ProseMirror .column-resize-handle": {
        position: "absolute",
        right: -2,
        top: 0,
        bottom: -2,
        width: 4,
        backgroundColor: "#adf",
        pointerEvents: "none",
    },

    "& .ProseMirror .tableWrapper": {
        overflowX: "auto",
    },

    "& .ProseMirror .resize-cursor": {
        cursor: "col-resize",
    },

    "& .ProseMirror th": {
        fontWeight: "bold",
    },

    "& .ProseMirror .small": {
        fontSize: "9pt",
        lineHeight: 1,
    },

    "& .ProseMirror ul, & .ProseMirror ol": {
        margin: "0 0 4mm 0",
        listStylePosition: "outside",
    },

    "& .ProseMirror ul": {
        listStyleType: "disc",
        margin: "0px 0 25px 0",
    },

    "& .ProseMirror ol": {
        listStyleType: "decimal",
        margin: "5px 0 5px 0",
    },

    "& .ProseMirror li": {
        display: "list-item",
        lineHeight: 1.2,
        margin: "0 0 1.5mm 0",
    },

    "& .ProseMirror img": {
        maxWidth: "100%",
        height: "auto",
    },

    "& .ProseMirror .page-break": {
        position: "relative",
        margin: "24px 0",
        borderTop: "2px dashed rgba(0,0,0,0.35)",
    },

    "& .ProseMirror .page-break::after": {
        content: `"${t("pageBreak")}"`,
        position: "absolute",
        top: "-10px",
        left: "50%",
        transform: "translateX(-50%)",
        background: "white",
        padding: "0 8px",
        fontSize: "12px",
        color: "rgba(0,0,0,0.55)",
    },
});
